import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { DashboardHeader } from "@/components/DashboardHeader";
import { ClinicalPageShell } from "@/components/clinical";
import { SettingsSectionBack } from "@/components/settings/SettingsSectionHub";
import { BillingPaymentsCenter } from "@/components/settings/BillingPaymentsCenter";
import { BillingRecoveryTour } from "@/components/ProductTour";

export const Route = createFileRoute("/app/settings/billing")({
  component: BillingSettingsPage,
  head: () => ({ meta: [{ title: "Facturación — Structura Market" }] }),
});

function BillingSettingsPage() {
  const navigate = useNavigate();
  return (
    <div>
      <DashboardHeader title="Facturación" />
      <ClinicalPageShell offset="none">
        <div className="mx-auto w-full max-w-3xl space-y-4 p-4">
        <SettingsSectionBack
          title="Facturación"
          description="Suscripción, pagos y recuperación"
          onBack={() => void navigate({ to: "/app/settings", search: {} as never })}
        />
        <BillingPaymentsCenter />
        <BillingRecoveryTour />
      </div>
    </ClinicalPageShell>
    </div>
  );
}
